module.exports = __webpack_public_path__ + "media/entities/32-74647ce8.png";